import { render, staticRenderFns } from "./GroupFilterBlock.vue?vue&type=template&id=74f19b99"
import script from "./GroupFilterBlock.vue?vue&type=script&lang=js"
export * from "./GroupFilterBlock.vue?vue&type=script&lang=js"
import style0 from "./GroupFilterBlock.vue?vue&type=style&index=0&id=74f19b99&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports